// OLD CRAP ---------------------------------------------------------------------------------------------
// OVERALL ---------------------------------------------------------------------------------------------
// Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        });
      }
    }
  });

$(".burger-menu").on("click",function(){
  $(".main-nav").toggleClass("active");
});

$("body").on("click",".cta-one-click",function(){
  $(this).addClass("no-click");
});

$("#gallery-popup").addClass("hide");

$("#gelerie-picto").on("click",function(){
  $("#gallery-popup").removeClass("hide");
});

$("#close-btn").on("click",function(){
  $("#gallery-popup").addClass("hide");
});

// Other things ---------------------------------------------------------------------------------------------

// OWL CAROUSEL

$('.carousel-property .item').magnificPopup({
  delegate: 'a', // child items selector, by clicking on it popup will open
  type: 'image',
  gallery:{
    enabled:true
  }
});


$( window ).on( "load", function() {

  $('.carousel-property.owl-carousel').owlCarousel({
    margin: 10,
    loop: true,
    autoWidth: true,
    nav: true,
    navText: [
      "<i class='fa fa-caret-left'></i>",
      "<i class='fa fa-caret-right'></i>"
    ], responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 2
      }
    }
  });

});


$('#carousel .owl-carousel').owlCarousel({
  center:true,
  stagePadding: 100,
  loop: true,
  autoWidth: true,
  margin: 20,
  nav: true,
  navText: [
    "<i class='fa fa-caret-left'></i>",
    "<i class='fa fa-caret-right'></i>"
  ], responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    1000: {
      items: 3
    }
  }
});


$('#carousel-testimonials').owlCarousel({
  loop: true,
  margin: 20,
  nav: true,
  autoplay: true,
  autoplayTimeout: 3500,
  navText: [
    "<i class='fa fa-caret-left'></i>",
    "<i class='fa fa-caret-right'></i>"
  ], responsive: {
    0: {
      items: 1
    },
    600: {
      items: 2
    },
    1000: {
      items: 3
    }
  }
});


// LANG MENU

$('#lang-nav').hover(function(){
  $('#lang-nav').toggleClass('open');
  $('#lang-nav').toggleClass('disableAfter');
})


// CONTACT FORM MENU

$(".contactBtn").click(function() {
  $('#form-contact').toggleClass('disguise');
});

$(".close").click(function() {
  $('#form-contact').addClass('disguise');
});


// CALL ME BACK POPUP

$('.call').on('click', function(e) {
  e.preventDefault();
  $('#call-popup').toggleClass('show-popup');
});

$('.close').on('click', function(e) {
  e.preventDefault();
  $('#call-popup').toggleClass('show-popup');
});

function isNumberKey(evt){
  var charCode = (evt.which) ? evt.which : event.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57))
    return false;
  return true;
}

// SCROLL TO

$(".scroll-down").click(function() {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#content").offset().top
  }, 2000);
});

$(".plan-trip").click(function() {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#contact-form").offset().top
  }, 1500);
});

$(".book-contact").click(function() {
  $([document.documentElement, document.body]).animate({
    scrollTop: $("#contact-section").offset().top
  }, 1500);
});

// MOBILE MENU

$(document).ready(function(){
  $('#nav-icon').click(function(){
    $(this).toggleClass('open');
  });
});


$('#nav-icon').click(function(){

  if($('#nav-icon').hasClass('open')){
    $('.mobile-menu-container').removeClass('opened');
    $('#menu-close').removeClass('opened');
    $('.main-header').removeClass('fixed');

  }
  else{

    $('.mobile-menu-container').addClass('opened');
    $('#menu-close').addClass('opened');
    $('.main-header').addClass('fixed');
  }
});


$('.mobile-menu-container').click(function(){

  if($('#nav-icon').hasClass('open')){
    $('.mobile-menu-container').removeClass('opened');
    $('#menu_close').removeClass('opened');
    $('#menu_close').removeClass('fixed');
    $('.main-header').removeClass('fixed');
    $('#nav-icon').removeClass('open');
  }
  else{

  }
})


$('#buy').on('change', function() {

  if( this.value === "no"){
    $('.select-hide').addClass("hide");
  }else{
    $('.select-hide').removeClass("hide");
  }
});


// SHOW MORE

$(".show-more").click(function() {
  $('.property-region-description').toggleClass('hideContent');
  $('.show-more').toggleClass('display');
  $('.show-less').toggleClass('display');
});

$(".show-less").click(function() {
  $('.property-region-description').toggleClass('hideContent');
  $('.show-more').toggleClass('display');
  $('.show-less').toggleClass('display');
});


// SHARE BUTTONS

$('.share').click(function() {
  $('#social-share').toggleClass('hover');
});



$("#guide-container img").click(function() {
  $("#guide-container").flipBook({
        pdfUrl: '/pdf/buyerguide-uniqestates.pdf',
        lightBox: true,
        lightBoxFullscreen: true,
        lightboxBackground: 'rgba(0,0,0,.8)',
  });
});


// DAILY WINNER POPUP

$('.close-daily').click(function() {
  $("#daily-tvshow-popup").hide();
});

$('.close-daily, .winner-day').click(function(){
  $('.yvideo').each(function(){
    var el_src = $(this).attr("src");
    $(this).attr("src",el_src);
  });
});

$("#daily-tvshow-popup").delay(1600).queue(function(next) {
    $(this).addClass("active-pp");
    next();
});



$('.winner-day').click(function() {
  $(".winner-day").removeClass("active-date");
  $(this).toggleClass('active-date');
});

$('#day-one').click(function() {
  $(".daily-video").removeClass("displayed");
  $("#day-one-content").addClass("displayed");
});

$('#day-two').click(function() {
  $(".daily-video").removeClass("displayed");
  $("#day-two-content").addClass("displayed");
});

$('#day-three').click(function() {
  $(".daily-video").removeClass("displayed");
  $("#day-three-content").addClass("displayed");
});

$('#day-four').click(function() {
  $(".daily-video").removeClass("displayed");
  $("#day-four-content").addClass("displayed");
});


// WINNER POPUP

$('.close-winner').click(function() {
  $("#winner-popup").hide();
});

$("#winner-popup").delay(1600).queue(function(next) {
  $(this).addClass("active-pp");
  next();
});



// GLOBAL POPUP

// Vérifie si la date de la dernière fermeture existe dans le stockage local
const lastClosedDates = JSON.parse(localStorage.getItem('lastClosedDates')) || {};

// Gestion de l'affichage des popups
$('.popup-frame').each(function() {
  const popup = $(this);
  const popupId = popup.attr('id');

  if (!lastClosedDates[popupId] || daysSinceLastClosed(new Date(lastClosedDates[popupId])) > 1) {
    if (!popup.hasClass('delay')) {
      // Affiche le popup avec animation fade in
      popup.fadeIn();
    } else {
      // Si le popup a la classe "delay", ajoute un gestionnaire de scroll
      $(window).on('scroll', function() {
        const scrollPercentage = (($(window).scrollTop() + $(window).height()) / $(document).height()) * 100;
        if (scrollPercentage >= 50) {
          // Affiche le popup avec animation fade in
          popup.fadeIn();
          // Retire le gestionnaire de scroll après affichage du popup
          $(window).off('scroll');
        }
      });
    }
  }

  // Gestion du clic sur le bouton de fermeture du popup
  popup.find('.close-popup, #event-popup-btn-' + popupId).on('click', function() {
    // Masque le popup avec animation fade out
    popup.fadeOut();
    // Enregistre la date de fermeture dans le stockage local
    lastClosedDates[popupId] = new Date().toUTCString();
    localStorage.setItem('lastClosedDates', JSON.stringify(lastClosedDates));
  });

  // Gestion du clic sur un élément avec la classe ".close-btn"
  popup.find('.close-btn').on('click', function() {
    // Masque le popup avec animation fade out
    popup.fadeOut();
    // Enregistre la date de fermeture dans le stockage local
    lastClosedDates[popupId] = new Date().toUTCString();
    localStorage.setItem('lastClosedDates', JSON.stringify(lastClosedDates));
  });
});

// Fonction pour calculer le nombre de jours écoulés depuis la dernière fermeture du popup
function daysSinceLastClosed(lastClosedDate) {
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - lastClosedDate.getTime();
  return timeDifference / (1000 * 60 * 60 * 24);
}


// JOBS TABLE

$("li.job-switch").first().addClass("active");
$('.job-switch').on('click', function(event) {
  event.preventDefault();

  // Ajouter la classe "active" à l'élément ahref cliqué
  $('.job-switch').removeClass('active');
  $(this).addClass('active');

  // Récupérer l'index de l'élément ahref cliqué
  const clickedIndex = $('.job-switch').index(this);

  // Afficher uniquement le contenu div correspondant à l'index de l'élément ahref cliqué
  $('.job-content').hide();
  $('.job-content').eq(clickedIndex).show();
});


// CUSTOM SELECT

$("#sort-form select").each(function () {
  var $this = $(this),
      numberOfOptions = $this.children("option").length;

  // Cache le "select" natif
  $this.addClass("s-hidden");

  // Ajoute un conteneur personnalisé
  $this.wrap('<div class="select"></div>');
  $this.after('<div class="styledSelect"></div>');

  // Initialise le conteneur avec la valeur actuellement sélectionnée
  var $styledSelect = $this.next("div.styledSelect");
  var selectedText = $this.find("option:selected").text(); // Récupère le texte de l'option sélectionnée
  $styledSelect.text(selectedText);

  // Crée la liste des options
  var $list = $("<ul />", {
    class: "options",
  }).insertAfter($styledSelect);

  for (var i = 0; i < numberOfOptions; i++) {
    $("<li />", {
      text: $this.children("option").eq(i).text(),
      rel: $this.children("option").eq(i).val(),
    }).appendTo($list);
  }

  var $listItems = $list.children("li");

  // Vérifie si une sélection est enregistrée dans le localStorage
  var savedValue = sessionStorage.getItem("selectedOption");
  if (savedValue) {
    // Met à jour l'affichage selon la sélection enregistrée
    $listItems.each(function () {
      if ($(this).attr("rel") === savedValue) {
        $(this).addClass("used");
        $styledSelect.text($(this).text());
        $this.val(savedValue);
      }
    });
  }

  // Affiche/Masque les options
  $styledSelect.click(function (e) {
    e.stopPropagation();
    $("div.styledSelect.active").each(function () {
      $(this).removeClass("active").next("ul.options").hide();
    });
    $(this).toggleClass("active").next("ul.options").toggle();
  });

  // Gère la sélection d'une option
  $listItems.click(function (e) {
    e.stopPropagation();

    // Ajoute la classe "used" sur l'élément sélectionné et la retire des autres
    $listItems.removeClass("used");
    $(this).addClass("used");

    var selectedValue = $(this).attr("rel");
    $styledSelect.text($(this).text()).removeClass("active");
    $this.val(selectedValue);
    $list.hide();

    // Enregistre la sélection dans le localStorage
    sessionStorage.setItem("selectedOption", selectedValue);

    // Soumet automatiquement le formulaire
    $this.closest("form").submit();
  });

  // Masque les options si l'utilisateur clique ailleurs
  $(document).click(function () {
    $styledSelect.removeClass("active");
    $list.hide();
  });

  // Si un bouton "submit" est cliqué, utilise la première option

  if (window.location.href.indexOf('sort_by=') === -1) {
    var firstOptionValue = $this.children("option").first().val();
    var firstOptionText = $this.children("option").first().text();

    // Met à jour la valeur et le texte du conteneur stylisé
    $this.val(firstOptionValue);
    $styledSelect.text(firstOptionText);

    // Enregistre la première option dans le sessionStorage
    sessionStorage.setItem("selectedOption", firstOptionValue);
    $('.options li').removeClass('used');
    $('.options li:first-child').addClass('used');
  }


});



// AUTO SCROLL AFTER SEARCH

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.search) {
    const searchElement = document.getElementById('search');
    if (searchElement) {
      searchElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
});


// WHATSAPP BUTTON

$('.open-box, #whatsapp-box-btn').click(function() {
  $("#whatsapp-box").toggleClass("box-active");
});

$('main').click(function() {
  $("#whatsapp-box").removeClass("box-active");
});

window.addEventListener("scroll", function () {
  let link = document.querySelector("#whatsapp-box"); // Remplace "your-class" par la classe à cibler

  if (link) {
    link.classList.remove("box-active"); // Supprime la classe au scroll
  }
});


// CONTACT SCROLL LOCATIONS

const $wrapper = $('.contacts-wrapper');
let isDragging = false;
let startX, scrollLeft;

$wrapper.on('mousedown', function(e) {
  isDragging = true;
  startX = e.pageX - $wrapper.offset().left;
  scrollLeft = $wrapper.scrollLeft();
  $(this).css('cursor', 'grabbing');
});

$wrapper.on('mouseleave mouseup', function() {
  isDragging = false;
  $(this).css('cursor', 'grab');
});

$wrapper.on('mousemove', function(e) {
  if (!isDragging) return;
  e.preventDefault();
  const x = e.pageX - $wrapper.offset().left;
  const walk = (x - startX) * 2; // SPEED
  $wrapper.scrollLeft(scrollLeft - walk);
});


// AUTO SELECT LOCATION

$('.optionChanger').on('click', function() {
  $('#contact').val($(this).data('value'));
});



// HIDE WEBSITE - PRINT SCREEN

const $screen = $('#protection-screen').hide();
let active = false;

$(document).on('keydown keyup', e => {
  const show = e.type === 'keydown' && (e.metaKey || e.ctrlKey);
  if (show !== active) {
    active = show;
    $screen.stop(true, true).fadeToggle(show).toggleClass('hidden', !show);
  }
});

$(window).on('blur', () => {
  if (active) {
    active = false;
    $screen.stop(true, true).fadeOut().addClass('hidden');
  }
});


// CHART INVESTOR

const cityData = {
  torrevieja: { price2015: 1071, price2025: 2079 },
  orihuela: { price2015: 1402, price2025: 2776 },
  sanpedro: { price2015: 1021, price2025: 1864 },
  finestrat: { price2015: 1714, price2025: 3073 },
  estepona: { price2015: 1472, price2025: 3681 },
  marbella: { price2015: 2288, price2025: 5092 },
};

const averagePrice = {
  torrevieja: { yearly: 9.41 },
  orihuela: { yearly: 9.80 },
  sanpedro: { yearly: 8.25 },
  finestrat: { yearly: 7.93 },
  estepona: { yearly: 15.00 },
  marbella: { yearly: 12.25 },
};

// Fonction d'animation d'un pourcentage vers une valeur cible
function animatePercentage($element, targetValue, suffix = '%') {
  $({ countNum: 0 }).animate(
      { countNum: targetValue },
      {
        duration: 500,
        easing: 'swing',
        step: function () {
          $element.text(this.countNum.toFixed(2) + suffix);
        },
        complete: function () {
          $element.text(targetValue.toFixed(2) + suffix);
        }
      }
  );
}

function updateData(city) {
  const data = cityData[city];
  const average = averagePrice[city];
  const change = ((data.price2025 - data.price2015) / data.price2015) * 100;

  $('#val-2025').text(`€ ${data.price2025}`);
  $('#val-2015').text(`€ ${data.price2015}`);
  animatePercentage($('#change'), change, '%');
  animatePercentage($('#yearly'), average.yearly, '% /');
}

$('#city-list li').click(function () {
  $('#city-list li').removeClass('active');
  $(this).addClass('active');
  const selectedCity = $(this).data('city');
  updateData(selectedCity);
});

// Initial display
updateData('torrevieja');




// FAQ INVESTOR

$(".faq-element").on("click", function(e) {
  e.stopPropagation();
  const $current = $(this).closest(".faq-element");
  $(".faq-element").not($current).removeClass("open-faq").find("p").addClass("hide-text");
  $current.find("p").toggleClass("hide-text");
  $current.toggleClass("open-faq");
});

$(document).on("click", function() {
  $(".faq-element").removeClass("open-faq").find("p").addClass("hide-text");
});



